import { useCallback, useEffect } from 'react';
import dashboardSelectors from '../selectors';
import action from '../actions';
import { useAppDispatch } from 'store/hooks';
import { IApiGetScreensParam } from 'modules/dashboard/interfaces/api';

const useGetListScreens = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const screensList = dashboardSelectors.getListScreens();
  const screensParams = dashboardSelectors.getScreensParam();
  
  const mutate = useCallback(
    (params: IApiGetScreensParam) => {
      dispatch(action.setScreensParam(params));
    },
    [dispatch]
  );

  useEffect(() => {
    if (isLazy) return;
    mutate({
      ...screensParams,
      page: 1,
    });
  }, []);

  return {
    screensList,
    screensParams,
    mutate,
  };
};

export default useGetListScreens;
